import React from "react";

interface PageContentProps {
  children?: React.ReactNode;
}

export default function PageContent({ children }: PageContentProps) {
  return <div className="h-app-module-page-content">{children}</div>;
}
